import { useEffect, useState } from 'react';
import { billingApi } from '../api/billing.api';
import type { GuaranteeStatus } from '../types/guarantee.types';

/**
 * The shop's AR Live Guarantee status, or null.
 *
 * `null` is the expected answer for anyone who has not subscribed yet, so it
 * is not an error state. `billingApi.getGuarantee` already swallows transport
 * failures into `null`, which leaves this hook with no error channel to
 * expose: callers must fail closed on `loading || !guarantee` and render no
 * numeric promise at all rather than a half-populated one.
 */
export function useGuarantee() {
  const [guarantee, setGuarantee] = useState<GuaranteeStatus | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const data = await billingApi.getGuarantee();
      if (cancelled) return;
      setGuarantee(data);
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { guarantee, loading };
}
